"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetBlockedDomains {
    static getAttributeTypeMap() {
        return GetBlockedDomains.attributeTypeMap;
    }
}
GetBlockedDomains.discriminator = undefined;
GetBlockedDomains.attributeTypeMap = [
    {
        "name": "domains",
        "baseName": "domains",
        "type": "Array<string>"
    }
];
exports.GetBlockedDomains = GetBlockedDomains;
//# sourceMappingURL=getBlockedDomains.js.map